import * as fromMaterials from '../actions/materials.action';

import { MakeEntitie } from '../makeentitie';

export interface MaterialsState {
  entities: { [pk: number]: any };
  loaded: boolean;
  loading: boolean;
}

export const initialState: MaterialsState = {
  entities: {},
  loaded: false,
  loading: false,
};

export function reducer(state = initialState, action: fromMaterials.MaterialsAction): MaterialsState {
  switch (action.type) {
    case fromMaterials.LOAD_MATERIALS: {
      return {
        ...state,
        loading: true,
      };
    }

    case fromMaterials.LOAD_MATERIALS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case fromMaterials.LOAD_MATERIALS_SUCCESS: {
      const materials = action.payload;

      return {
        ...state,
        loading: false,
        loaded: true,
        entities: materials,
      };
    }
  }

  return state;
}

export const getMaterialsEntities = (state: MaterialsState) => state.entities;
export const getMaterialsLoading = (state: MaterialsState) => state.loading;
export const getMaterialsLoaded = (state: MaterialsState) => state.loaded;
